
import React from 'react'
import useUserStore from '../store/useUserStore';
import { useNavigate, Link, useLocation } from 'react-router-dom';

export default function Header() {
    const { user, setDB } = useUserStore();
    const navigate = useNavigate();
    const location = useLocation();
    const changeDBHandler = async () => {
        await setDB();
        // if (location.pathname === '/dashboard') {
        //     window.location.reload();
        // } else {
        navigate('/dashboard');   // Redirect to dashboard
        // }
    }
    return (
        <nav className="navbar p-0 fixed-top d-flex flex-row">
            <div className="navbar-brand-wrapper d-flex d-lg-none align-items-center justify-content-center">
                <a className="navbar-brand brand-logo-mini" href="index.html"><img src={`${process.env.PUBLIC_URL}/assets/images/logo-mini.svg`} alt="logo" /></a>
            </div>
            <div className="navbar-menu-wrapper flex-grow d-flex align-items-stretch">
                <button className="navbar-toggler navbar-toggler align-self-center" type="button" data-toggle="minimize">
                    <span className="mdi mdi-menu"></span>
                </button>

                <ul className="navbar-nav navbar-nav-right">
                    <li className="nav-item dropdown d-none d-lg-block">
                        <button className="nav-link btn btn-success create-new-button"

                            style={{ "backgroundColor": "rgb(0, 210, 91)" }}
                            aria-expanded="false"
                            onClick={changeDBHandler}
                            href="#"> {user.db === 'tdr'
                                ? 'Switch TDR to PRO'
                                : user.db === 'pro'
                                    ? 'Switch PRO to TDR'
                                    : 'Switch DB'}</button>
                        {/* <div className="dropdown-menu dropdown-menu-end navbar-dropdown preview-list" aria-labelledby="createbuttonDropdown1">

                            <div className="dropdown-divider"></div>
                            <a className="dropdown-item preview-item">
                                <div className="preview-thumbnail">
                                    <div className="preview-icon bg-dark rounded-circle">
                                        <i className="mdi mdi-file-outline text-primary"></i>
                                    </div>
                                </div>
                                <div className="preview-item-content">
                                    <p className="preview-subject ellipsis mb-1">TDR</p>
                                </div>
                            </a>
                            <div className="dropdown-divider"></div>
                            <a className="dropdown-item preview-item">
                                <div className="preview-thumbnail">
                                    <div className="preview-icon bg-dark rounded-circle">
                                        <i className="mdi mdi-web text-info"></i>
                                    </div>
                                </div>
                                <div className="preview-item-content">
                                    <p className="preview-subject ellipsis mb-1">Production</p>
                                </div>
                            </a>


                        </div> */}
                    </li>
                    <li className="nav-item nav-settings d-none d-lg-block">
                        <a className="nav-link" href="#">
                            <i className="mdi mdi-view-grid"></i>
                        </a>
                    </li>
                    <li className="nav-item dropdown border-left">
                        <a className="nav-link count-indicator dropdown-toggle" id="messageDropdown" href="#" data-bs-toggle="dropdown" aria-expanded="false">
                            <i className="mdi mdi-email"></i>
                            <span className="count bg-success"></span>
                        </a>
                        <div className="dropdown-menu dropdown-menu-end navbar-dropdown preview-list" aria-labelledby="messageDropdown">
                            <h6 className="p-3 mb-0">Messages</h6>
                            <div className="dropdown-divider"></div>
                            <a className="dropdown-item preview-item">
                                <div className="preview-thumbnail">
                                    <img src={`${process.env.PUBLIC_URL}/assets/images/faces/face4.jpg`} alt="image" className="rounded-circle profile-pic" />
                                </div>
                                <div className="preview-item-content">
                                    <p className="preview-subject ellipsis mb-1">Mark send you a message</p>
                                    <p className="text-muted mb-0"> 1 Minutes ago </p>
                                </div>
                            </a>
                            <div className="dropdown-divider"></div>
                            <a className="dropdown-item preview-item">
                                <div className="preview-thumbnail">
                                    <img src={`${process.env.PUBLIC_URL}/assets/images/faces/face2.jpg`} alt="image" className="rounded-circle profile-pic" />
                                </div>
                                <div className="preview-item-content">
                                    <p className="preview-subject ellipsis mb-1">Cregh send you a message</p>
                                    <p className="text-muted mb-0"> 15 Minutes ago </p>
                                </div>
                            </a>
                            <div className="dropdown-divider"></div>
                            <a className="dropdown-item preview-item">
                                <div className="preview-thumbnail">
                                    <img src={`${process.env.PUBLIC_URL}/assets/images/faces/face3.jpg`} alt="image" className="rounded-circle profile-pic" />
                                </div>
                                <div className="preview-item-content">
                                    <p className="preview-subject ellipsis mb-1">Profile picture updated</p>
                                    <p className="text-muted mb-0"> 18 Minutes ago </p>
                                </div>
                            </a>
                            <div className="dropdown-divider"></div>
                            <p className="p-3 mb-0 text-center">4 new messages</p>
                        </div>
                    </li>
                    <li className="nav-item dropdown border-left">
                        <a className="nav-link count-indicator dropdown-toggle" id="notificationDropdown" href="#" data-bs-toggle="dropdown">
                            <i className="mdi mdi-bell"></i>
                            <span className="count bg-danger"></span>
                        </a>
                        <div className="dropdown-menu dropdown-menu-end navbar-dropdown preview-list" aria-labelledby="notificationDropdown">
                            <h6 className="p-3 mb-0">Notifications</h6>
                            <div className="dropdown-divider"></div>
                            <a className="dropdown-item preview-item">
                                <div className="preview-thumbnail">
                                    <div className="preview-icon bg-dark rounded-circle">
                                        <i className="mdi mdi-calendar text-success"></i>
                                    </div>
                                </div>
                                <div className="preview-item-content">
                                    <p className="preview-subject mb-1">Event today</p>
                                    <p className="text-muted ellipsis mb-0"> Just a reminder that you have an event today </p>
                                </div>
                            </a>
                            <div className="dropdown-divider"></div>
                            <a className="dropdown-item preview-item">
                                <div className="preview-thumbnail">
                                    <div className="preview-icon bg-dark rounded-circle">
                                        <i className="mdi mdi-cog text-danger"></i>
                                    </div>
                                </div>
                                <div className="preview-item-content">
                                    <p className="preview-subject mb-1">Settings</p>
                                    <p className="text-muted ellipsis mb-0"> Update dashboard </p>
                                </div>
                            </a>
                            <div className="dropdown-divider"></div>
                            <a className="dropdown-item preview-item">
                                <div className="preview-thumbnail">
                                    <div className="preview-icon bg-dark rounded-circle">
                                        <i className="mdi mdi-link-variant text-warning"></i>
                                    </div>
                                </div>
                                <div className="preview-item-content">
                                    <p className="preview-subject mb-1">Launch Admin</p>
                                    <p className="text-muted ellipsis mb-0"> New admin wow! </p>
                                </div>
                            </a>
                            <div className="dropdown-divider"></div>
                            <p className="p-3 mb-0 text-center">See all notifications</p>
                        </div>
                    </li>
                    <li className="nav-item dropdown">
                        <a className="nav-link" id="profileDropdown" href="#" data-bs-toggle="dropdown">
                            <div className="navbar-profile">
                                <img className="img-xs rounded-circle" src={`${process.env.PUBLIC_URL}/assets/images/faces/face15.jpg`} alt="" />
                                <p className="mb-0 d-none d-sm-block navbar-profile-name">{user.name}</p>
                                <i className="mdi mdi-menu-down d-none d-sm-block"></i>
                            </div>
                        </a>
                        <div className="dropdown-menu dropdown-menu-end navbar-dropdown preview-list" aria-labelledby="profileDropdown">
                            <h6 className="p-3 mb-0">Profile</h6>
                            <div className="dropdown-divider"></div>
                            <a className="dropdown-item preview-item">
                                <div className="preview-thumbnail">
                                    <div className="preview-icon bg-dark rounded-circle">
                                        <i className="mdi mdi-cog text-success"></i>
                                    </div>
                                </div>
                                <div className="preview-item-content">
                                    <p className="preview-subject mb-1">Settings</p>
                                </div>
                            </a>
                            <div className="dropdown-divider"></div>
                            <a className="dropdown-item preview-item">
                                <div className="preview-thumbnail">
                                    <div className="preview-icon bg-dark rounded-circle">
                                        <i className="mdi mdi-logout text-danger"></i>
                                    </div>
                                </div>

                                <div className="preview-item-content">
                                    <Link to="/">
                                        <p className="preview-subject mb-1">Log out</p>
                                    </Link>

                                </div>


                            </a>
                            <div className="dropdown-divider"></div>
                            <p className="p-3 mb-0 text-center">Advanced settings</p>
                        </div>
                    </li>
                </ul>
                <button className="navbar-toggler navbar-toggler-right d-lg-none align-self-center" type="button" data-toggle="offcanvas">
                    <span className="mdi mdi-format-line-spacing"></span>
                </button>
            </div>
        </nav>
    )
}